// extracted by mini-css-extract-plugin
module.exports = {"Holder":"Slider_Holder__1cwxG","Image":"Slider_Image__3x8bc","Active":"Slider_Active__10fV4"};